<mat-card class="benefit-image-card" [ngClass]="layout ? layout : ''">
  <div class="benefit-image-card_header">
    <div class="benefit-image-card_image" [style.background-image]="'url(' + bannerImage + ')'"></div>
  </div>
  <mat-card-content>
    <mat-card-title>
      <ng-content select="[card-title]"></ng-content>
    </mat-card-title>
    <div class="benefit-image-card_body-text">
      <p (click)="manipulateText($event.currentTarget)" [innerHTML]="cardText" class="title"></p>
    </div>
    <div class="benefit-image-card_more-info">
      <div class="code">{{ cardCode }}</div>
      <div class="benefit-image-card_more-info_button" [class.large-container]="textLengthCheck(cardText)">
        <ng-content select="[card-button]"></ng-content>
      </div>
    </div>
  </mat-card-content>
</mat-card>